import { toast } from 'react-toastify'
import moment from 'moment'
import { createAxiosInstance, getModificaciones, esEntero, indexBy, attachFilesToEntity } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'
import { displayMessages, uploadFiles } from './common'
import FileDownload from 'react-file-download'
import { getSolicitud as getSolicitudOS } from './otrosi'

export function getSolicitud(id) {
	const axios = createAxiosInstance()

	return (dispatch) => {
		axios.get(`${API_URL}/solicitudes/servicios/${id}`)
		.then((res) => {
			let cotizacionesAprobadas = [];
			const solicitud = res.data.solicitud
			const aprobadores = res.data.aprobadores

			for (let index = 0; index < solicitud.servicios.length; index++) {
				cotizacionesAprobadas = solicitud.servicios[index].cotizaciones.filter(ele => ele.estado === 4)
				solicitud.servicios[index].cotizaciones_aprobar = cotizacionesAprobadas;
			}

			dispatch({ type: types.OBTENER_SOLICITUD_SERVICIO, payload: { solicitud, aprobadores } })
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}


}


export function updateInputs(path, value, id = null, immutable = true) { //Alerta: colocar el id para activar el boton de actualizacion
	return (dispatch) => {

        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO1, payload: { path, value, immutable } })
		fn0(dispatch)

		const pathArray = path.split('.')

		let entity = esEntero(pathArray.slice(-2)[0]) ? pathArray.slice(-3)[0] : pathArray.slice(-2)[0]
		const attribute = pathArray.slice(-2)[1]

		switch (entity) {
			
			case 'solicitud':
				entity = 'Solicitude'
			break

			case 'servicio':
			case 'servicios':
				entity = 'Servicio'
			break


            case 'cotizacion':
            case 'cotizacione':
            case 'cotizaciones':
            case 'cotizaciones_aprobar':
				entity = 'Cotizacione'
            break



			case 'documento':
			case 'documentos':
				entity = 'Documento'
			break
		}

		if (id) {
			const fn2 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO, payload: { id, entity, attribute, value, action: 'edit' } })
			fn2(dispatch)
		}

	}
}



export function addFile(url, actions) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile','data'])
		const files = [data]
		actions.push(() => displayMessages(dispatch, { success: 'Los archivos han sido guardados exitosamente' }))
		dispatch(uploadFiles(url, files, actions))
	}
}




export function removeFiles() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const fns = []
		getState().solicitudservicio.getIn(['solicitud', 'adjuntos']).filter(a => a.get('id') && a.get('selected')).map(a => {
			fns.push(() => axios.delete(`${API_URL}/files/${a.get('id')}`))
        })
        const id = getState().solicitudservicio.get('id')
		Promise.all(fns.map(x => x()))
		.then(() => {			
            displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })            
            dispatch(getSolicitud(id))
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}



export function addProveedorCotizacion(payload) {
	return (dispatch, getState) => {
		const path = payload.path.split('.').slice(0,4)
		const cotizaciones = getState().solicitudservicio.getIn(path)
		if (cotizaciones.filter(x => x.getIn(['proveedore', 'id']) === payload.value.id).count() !== 0) {
			toast.warn(`El proveedor ${payload.value.nombre} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			let proveedor = getState().solicitudservicio.getIn(payload.path.split('.').slice(0,4)).toJS()
			proveedor = {...proveedor, ...payload.value}
			payload.value = proveedor
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO, payload })

			const servicio_id = getState().solicitudservicio.getIn(payload.path.split('.').slice(0,3)).get('id')
			const cotizacion_index =  payload.path.split('.').slice(-2)[0]
			const id = `${servicio_id}.${cotizacion_index}`

			dispatch(
				{ 
					type: types.ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO, 
					payload: { 
						id, 
						entity: 'Cotizaciones', 
						attribute: 'proveedore', 
						value: payload.value.id, 
						action: 'edit' 
					} 
				}
			)

			
		}
	}
}

export function addCotizacionAprobar(path) {
    return {
        type: types.ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO,
        payload: {
            path
        }
    }
}

export function seleccionarCotizacionAprobar(cotizacion_id, indexServicio, indexCotizacionAprobar) {

	return (dispatch, getState) => {
		const cotizacionesAprobar = getState().solicitudservicio.getIn(['solicitud', 'servicios', indexServicio, 'cotizaciones_aprobar'])
			.filter(cot => cot.get('id') == Number(cotizacion_id))
		if (cotizacionesAprobar.count() > 0) {
			toast.warn(`El proveedor ya ha sido seleccionado`, { bodyClassName: 'toastify-content toastify-warning' })
		} 
		else {
			const cotizaciones = getState().solicitudservicio.getIn(['solicitud', 'servicios', indexServicio, 'cotizaciones'])
			const cotizacionCompraDirecta = cotizaciones.filter(x => x.get('proveedor_id') == null)
			let esCompraDirecta = false
			if(cotizacionCompraDirecta.count() > 0){
				esCompraDirecta = true
				
			}
			dispatch({
				type: types.SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO,
				payload: {
					cotizacion_id,
					indexServicio,
					indexCotizacionAprobar,
					esCompraDirecta

				}
			})
		}
		
	}
}

export function addCotizacion(path, indexServicio) {

	return (dispatch, getState) => {

		const cotizaciones = getState().solicitudservicio.getIn(['solicitud', 'servicios', indexServicio, 'cotizaciones'])
		const numcotizaciones = cotizaciones ? cotizaciones.count() : 0

		dispatch({ type: types.ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO, payload: { path, indexServicio} })

	}


}



export function removeProveedorCotizacion(path) {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO, payload: { path } })
	}
}


export function updateSolicitudServicio() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO, payload: false })
		fn0(dispatch)

		const files = []
		const solicitud = getState().solicitudservicio.get('solicitud')
		const unchaged = getState().solicitudservicio.get('unchaged')
		const solicitud_id = getState().solicitudservicio.get('id')
		const serviciosNew = getState().solicitudservicio.getIn(['solicitud', 'servicios'])
		const serviciosdOld = getState().solicitudservicio.getIn(['unchaged', 'servicios'])
		const modificar = getState().solicitudservicio.get('addModificacion')
		const remove = getState().solicitudservicio.get('remove');		

		const errors = validateSolicitud(getState().solicitudservicio.get('solicitud'))

		if (errors.length > 0) {

			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
			//fn1(dispatch)
		} else {

			let serviciosNewCompraDirecta = getState().solicitudservicio.getIn(['solicitud', 'servicios'])

			let files = [];
			let modificaciones = [];


			const comprasDirectas = serviciosNewCompraDirecta.filter(servicio => servicio.get('compra_directa') && servicio.get('factura_compra_directa_servicios')).map(servicio => servicio.get('factura_compra_directa_servicios'))
			if (comprasDirectas.count() > 0 && solicitud.get('estado') >= 4 && solicitud.get('estado') <= 6) { 				
                files = attachFilesToEntity("FacturaCompraDirectaServicios", comprasDirectas)
            }

			if (modificar) {
				modificaciones = addModificacion(solicitud, unchaged);
			} else {
				modificaciones = getModificaciones(serviciosNew, serviciosdOld, 'Servicio', switchServicios)
			}
			
			modificaciones = [...modificaciones, ...remove];

			modificaciones = addProveedoresExternos(modificaciones)
			
			axios.put(`${API_URL}/solicitudes/servicios/${solicitud_id}`, modificaciones)
			.then(res => {	

				let cotizacionesAprobadas = [];
				const solicitud = res.data.solicitud	
				const aprobadores = res.data.aprobadores
				for (let index = 0; index < solicitud.servicios.length; index++) {
					cotizacionesAprobadas = solicitud.servicios[index].cotizaciones.filter(ele => ele.estado === 4)
					solicitud.servicios[index].cotizaciones_aprobar = cotizacionesAprobadas;
				}

				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_SERVICIO, payload: { solicitud, aprobadores } })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn2, fn3, fn4]))


			})
			.catch(err => {
				displayMessages(dispatch, err)
				fn1(dispatch)
			})

		}		
	}
}


export function recomendarCotizacion(indexServicio, indexCotizacion) {
	return (dispatch) => {
		dispatch({
			type: types.CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO,
			payload: {
				indexServicio,
				indexCotizacion
			}
		})

		dispatch({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO, payload: false })


	}
}



export function seleccionarAprobacion(servicioid, aprobadorid, aprobacionid) {
	return (dispatch) => {
		dispatch({
			type: types.CONMUTAR_SELECCION_APROBACION_SERVICIO,
			payload: {
				servicioid,
				aprobadorid, 
				aprobacionid
			}
		})
	}
}



export function registerApprovalResult(aprobaciones, result, indexServicio=null) {
	
	const ip = require('ip');
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().solicitudservicio.get('solicitud')

		const errors = result > 0 ? validateAprobacion(aprobaciones, result) : validateAprobacion(aprobaciones.first().get('observaciones'), result)

		const disCencos = solicitud.getIn(['servicios', indexServicio, 'cencos'])
		const aprobadas = aprobaciones.filter(a => a.get('estado') == 3)
		const aprobador_id = aprobadas.count() > 0 && aprobadas.first().get('aprobador_id')
		const cencos = aprobaciones.count() > 0 && aprobaciones.first().getIn(['cotizacione', 'servicios', 0, 'cencos'])
		const cenco = cencos.filter(c => c.get('responsable_id') == aprobador_id)
		let cenco_id = null


		if (cenco.count() > 0) {
			cenco_id = cenco.first().get('id')
		}

		// if (disCencos && result != 0) {
		// 	disCencos.map(c => {
		// 		if ((c.get('rubros').count() > 0) && c.get('id') == cenco_id) {
		// 			if (! c.getIn(['pivot', 'rubro_id'])) {
		// 				errors.push('Deben seleccionar un rubro si tiene rubros existentes')
		// 			}
		// 		}
		// 	})
		// }		
		
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {


			const modificaciones = []

			aprobaciones.map(a => {
				modificaciones.push({
					id: a.get('id'),
					entity: 'Aprobacione',
					value: { estado: result > 0 ? (a.get('estado') == 1 ? 4 : result) : 0, ip: ip.address(), observaciones: aprobaciones.first().get('observaciones') },
					action: 'edit'
				})
			})

			
			if (disCencos)
				disCencos.map(c => {
					if (c.getIn(['pivot', 'rubro_id'])) {
						modificaciones.push({
							id: c.getIn(['pivot', 'id']),
							entity: 'DisCencoServicio',
							value: { rubro_id: c.getIn(['pivot', 'rubro_id']) },
							action: 'edit'
						})
					}
				})


			dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO, payload: true }))


			axios.put(`${API_URL}/solicitudes/servicios/${solicitud.get('id')}`, modificaciones)
				.then(res => {

					const solicitud = res.data.solicitud	
					const aprobadores = res.data.aprobadores


					if (solicitud.estado === 0) {
						history.push(window.FOLDER + '/solicitudes/abiertas')
						displayMessages(dispatch, { success: 'La solicitud ha sido anulada' })
					} else {						
						
						if (solicitud.documento_origen) {
							const fn1 = (d) => d(getSolicitudOS(solicitud.id))
							fn1(dispatch)
						}

						const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_SERVICIO, payload: { solicitud, aprobadores } })
						fn0(dispatch)
						displayMessages(dispatch, { success: 'La solicitud ha sido guardada exitosamente' })
						dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO, payload: false }))
					}

				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO, payload: false }))
				})




		}
	}
}




export function displayModalCreateDocumento(show, title, mode, indexDocumento) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const proveedor = getState().solicitudservicioot.getIn(['solicitud', 'documentos', indexDocumento, 'proveedor_id'])
		const fn0 = () => axios.get(`${API_URL}/plantillas`)
		const fn1 = () => axios.get(`${API_URL}/garantias`)
		const fn2 = () => axios.get(`${API_URL}/documentos/contratos-anuales`, { params: { proveedor }})
		Promise.all([fn0(), fn1(), fn2()])
		.then(res => {
			const plantillas = res[0].data.data
			const garantias = res[1].data.data
			const contratos = res[2].data
			dispatch({ type: types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO, payload: { show, title, mode, indexDocumento, plantillas, garantias, contratos } })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}

export function displayModalCompraDirecta(show, title, servicio_id, cotizacion) {
    return {
        type: types.MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO,
        payload: {
            title,
            show,
            servicio_id,
            cotizacion
        }
    }
}

export function addFileCompraDirecta(path) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (data.get('clasificacion') && data.get('clasificacion') != 'Facturas') errors.push('Se requiere adjuntar un archivo de tipo Factura')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO1, payload: {path, value: data, immutable: true} })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}

export function createOrUpdateCompraDirecta() {
    return (dispatch, getState) => {

        const documentoNew = getState().solicitudservicio.getIn(['modalCreateCompraDirecta', 'data'])
		
        const cot_id = getState().solicitudservicio.getIn(['modalCreateCompraDirecta', 'cot_id'])
        const servicio_id = getState().solicitudservicio.getIn(['modalCreateCompraDirecta', 'servicio_id'])
        const cotizacion_idx = getState().solicitudservicio.getIn(['solicitud', 'cotizaciones']).findIndex(cot => cot.get('id') === cot_id)

        let servicios_idx = getState().solicitudservicio.getIn(['solicitud', 'cotizaciones', cotizacion_idx, 'servicios']).findIndex(servicio => servicio.get('id') === servicio_id)
        const errors = validateFacturaCompraDirecta(documentoNew)

        if (errors.length) {
            errors.forEach(x => {
                toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
            })
        } else {
            dispatch(displayModalCompraDirecta(false))
            dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.servicios.${servicios_idx}.factura_compra_directa_servicios`, documentoNew, servicio_id))
            servicios_idx = getState().solicitudservicio.getIn(['solicitud', 'servicios']).findIndex(servicio => servicio.get('id') === servicio_id)
            dispatch(updateInputs(`solicitud.servicios.${servicios_idx}.factura_compra_directa_servicios`, documentoNew, servicio_id))

			if (documentoNew.get('proveedor','nombre'))
				dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.proveedor_nombre_cp`, documentoNew.getIn(['proveedor','nombre']), cot_id))
			else
				dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.proveedor_nombre_cp`, documentoNew.get(['razon_social']), cot_id))

            
        }
    }
}



export function addGarantia(checked, index, id) {
	return (dispatch) => {
		if (checked) {
			dispatch({ type: types.ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO, payload: index })
		} else {
			dispatch({ type: types.REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO, payload: id })
		}
	}
}



export function createOrUpdateDocumento() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {


		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO, payload: false })


		fn0(dispatch)
		const fn3 = (d) => d(displayModalCreateDocumento(false))
		const solicitud = getState().solicitudservicio.get('id')
		const data = getState().solicitudservicio.get('modalCreateDocumento')	

		let documentoNew = data.get('data')
		let documentoOld = data.get('unchanged')
		const tipoDocumento = documentoNew.get('tipo')
		
		if ((tipoDocumento == 1) || (tipoDocumento == 3)) {
			documentoNew = documentoNew.set('fecha_inicio', moment().format('YYYY-MM-DD'))
		}

		if (tipoDocumento == 4) {
			const fecha_inicio = getState().solicitudservicio.getIn(['solicitud', 'documento_origen', 'fecha_inicio'])
			documentoNew = documentoNew.set('fecha_inicio', moment(fecha_inicio).format('YYYY-MM-DD'))
		}

		const errors = validateDocumento(documentoNew, data.get('contratoanual'))


		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
			fn1(dispatch)
		} else {
			
			documentoOld = documentoOld.set('garantias', indexBy(documentoOld.get('garantias'), 'id'))
			documentoNew = documentoNew.set('garantias', indexBy(documentoNew.get('garantias'), 'id'))
			const modificaciones = getModificaciones(documentoNew, documentoOld, 'Documento', switchDocumento)

			axios.put(`${API_URL}/solicitudes/servicios/${solicitud}`, modificaciones)
				.then(res => {
					const solicitud = res.data.solicitud
					const aprobadores = res.data.aprobadores					
					const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_SERVICIO, payload: { solicitud, aprobadores }})
					fn1(dispatch)
					fn2(dispatch)
					fn3(dispatch)
					displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})


		}
	}
}


export function registerCancelacion() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {

        const solicitud = getState().solicitudservicio.get('solicitud').set('estado', 0)
        const errors = validateSolicitud(solicitud)

        if (errors.length > 0) {
            errors.forEach(x => {
                toast.warning(x, {
                    bodyClassName: 'toastify-content toastify-warning'
                })
            })
        } else {
            const modificaciones = []
            modificaciones.push({
                id: solicitud.get('id'),
                entity: 'Solicitude',
                value: {
                    estado: 0,
                    motivo_cancelacion: solicitud.get('motivo_cancelacion'),
                    fecha_cancelacion: moment().format('YYYY-MM-DD')
                },
                action: 'edit'
            })

            axios.put(`${API_URL}/solicitudes/servicios/${solicitud.get('id')}`, modificaciones)
                .then(res => {
                    const solicitud = res.data.solicitud
                    const aprobadores = res.data.aprobadores
                    const fn0 = (d) => d({
                        type: types.ACTUALIZAR_SOLICITUD_SERVICIO,
                        payload: {
                            solicitud,
                            aprobadores
                        }
                    })
                    const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', {
                        bodyClassName: 'toastify-content toastify-success'
                    })
                    fn0(dispatch)
					fn1()


					if (solicitud.documento_origen) {
						const fn2 = (d) => d(getSolicitudOS(solicitud.id))
						fn2(dispatch)
					}			



                })
                .catch(err => {
                    console.log(err)
                    displayMessages(dispatch, err)
                })
        }
    }
}



export function previewDocumento(id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const documento = getState().solicitudservicio.getIn(['modalCreateDocumento', 'data'])
		const tipo = getState().common.getIn(['enums', 'documentos', 'tipos', `${documento.get('tipo')}`, 'NOMBRE'])

		axios.post(`${API_URL}/solicitudes/servicios/view/${id}`, {documento}, { responseType: 'arraybuffer' })
		.then(res => {			
			FileDownload(res.data, `PREV-${tipo}.pdf`);
		})
		.catch(err => {			
			const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data)))
			const obj = {
				response: {
					data: decodedString,
					status: 422
				}
			}
			displayMessages(dispatch, obj)
		})
	}
}




export function displayModalAddServicio(show, title, mode, index) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 })
		}
	}
}


export function addSolicitudServicioItem() {
	return (dispatch, getState) => {

		const data = getState().solicitudservicio.getIn(['modalAddServicio', 'data'])

		const errors = []
		if (!data.get('descripcion')) errors.push('La creación de servicios requiere de una descripción')
		if (data.get('cantidad') < 1) errors.push('La creación de servicios requiere que la cantidad sea superior a 0')
		if (data.get('cencos').count() === 0) errors.push('La creación de servicios requiere al menos de un centro de costo')
		if (data.get('cencos').filter(x => x.get('id') === null).count() > 0) errors.push('La creación de servicios requiere que todos los centros de costos estén definidos')
		if (data.get('cencos').filter(x => x.get(['pivot', 'porcentaje']) < 1).count() > 0) errors.push('El porcentaje en los cencos debe ser mayor a 0')

		const sumDist = data.get('cencos').reduce((a, b) => { a += Number(b.getIn(['pivot', 'porcentaje'])); return a }, 0)
		if (sumDist !== 100) errors.push('La creación de servicios requiere la suma de distribución entre cencos sea del 100%')

		if (errors.length > 0) {

			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})

		} else {

			const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO, payload: false })
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1 })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 })

			fn0(dispatch)
			fn1(dispatch)
			fn2(dispatch)

		}
	}
}

export function addCencoSolicitudServicioItem() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1 })
	}
}

export function removeCencosSolicitudServicioItem() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1 })
	}
}

export function removeSolicitudServicioItem() {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {



        const servicios = getState().solicitudservicio.getIn(['solicitud', 'servicios']).filter(x => x.get('id') && x.get('selected'))

        const modificaciones = []

        servicios.valueSeq().forEach(servicio => {

            const cencos = servicio.get('cencos')

            cencos.valueSeq().forEach(c => {
                modificaciones.push({
                    entity: 'DisCencoServicio',
                    id: c.getIn(['pivot', 'id']),
                    action: 'delete'
                })
            })

            modificaciones.push({
                entity: 'Servicio',
                id: servicio.get('id'),
                action: 'delete'
            })

        });

		dispatch({ type: types.ELIMINAR_ITEMS_SOLICITUD_SERVICIO, payload:{ remove: modificaciones } });
		
		
	}
}


export function enviarComentario() {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud_id = getState().solicitudservicio.getIn(['solicitud', 'id'])
		const usuario_id = getState().common.getIn(['user', 'id'])
		const id = getState().solicitudservicio.getIn(['comentario','id'])
		const comentario = getState().solicitudservicio.getIn(['comentario','texto'])
        const modificaciones = []

		if (id == null) {

			modificaciones.push({ 
				entity: 'Foro', 
				action: 'add', 
				id: null,
				value: {
					solicitud_id,
					usuario_id,
					comentario
				}
			})

		} else {

			modificaciones.push({
				id,
				entity: 'Foro',
				value: { comentario },
				action: 'edit'
			})
		}

		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1, payload: true })
		const fn2 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1, payload: false })

		fn1(dispatch)
		axios.put(`${API_URL}/solicitudes/servicios/${solicitud_id}`, modificaciones)
		.then(res => {
			const foros = res.data.solicitud.foros	
			const fn3 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1, payload: { foros } })
			fn3(dispatch)
			fn2(dispatch)
		})
		.catch(err => {
			displayMessages(dispatch, err)
			fn2(dispatch)
		})		
	}
}

export function editarComentario( id ) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_SERVICIO1, payload: { id } })
		fn1(dispatch)
	}
}

export function eliminarComentario(id) {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud = getState().solicitudservicio.getIn(['solicitud', 'id'])
        const modificaciones = []
		modificaciones.push({ entity: 'Foro', id, action: 'delete'})
        axios.put(`${API_URL}/solicitudes/servicios/${solicitud}`, modificaciones)
        .then(res => {
			const foros = res.data.solicitud.foros	
			const fn1 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1, payload: { foros } })
            fn1(dispatch)
			displayMessages(dispatch, { success: 'La eliminacion han sido realizadas exitosamente' })
        })
        .catch(err => {
            displayMessages(dispatch, err)
        })		
	}
}


export function crearAprobacionAdicional({ cotizacion, aprobador, motivo }) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        const errors = validarSolicitudAprobacionAdicionalServicio(cotizacion, aprobador, motivo);
        if (errors.length > 0) {
            displayMessages(dispatch, { error: errors });
            return;
        }
        const solicitud_id = getState().solicitudservicio.get('id');
        const modificaciones = [];
        modificaciones.push({
            id: null,
            entity: 'Aprobacione',
            action: 'add',
            value: {
                cotizacion_id: cotizacion.get('id'),
                aprobador_id: aprobador.id,
                estado: 1, // Pendiente de aprobación
                observaciones: motivo,
                tipo: 3
            }
        });
        axios.put(`${API_URL}/solicitudes/servicios/${solicitud_id}`, modificaciones)
            .then(res => {
                displayMessages(dispatch, { success: 'Aprobación adicional solicitada correctamente.' });
                dispatch(getSolicitud(solicitud_id));
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.ExceptionMessage) {
                    displayMessages(dispatch, { error: err.response.data.ExceptionMessage });
                } else {
                    displayMessages(dispatch, { error: 'Error al solicitar la aprobación adicional.' });
                }
            });
    };
}




///******* Shared ********///

const addProveedoresExternos = (modificaciones) => {
    modificaciones.forEach((m,i) => {
        if (m.value && m.entity == 'Servicio' && m.attribute == 'factura_compra_directa_servicios' && m.action == 'create') {
            if (m.value.proveedor) {
                modificaciones[i].value.razon_social = m.value.proveedor.nombre
                delete modificaciones[i].value.proveedor
            } else {
                modificaciones.push({
					entity: 'ProveedorExterno',
					value: {
						nombre: m.value.razon_social,
					},
					action: 'add'
				});
            }
        }
    })
    return modificaciones
}


const validateAprobacion = (data, extra) => {
	const errors = []
	if (extra == 2 && data.filter(x => x.get('estado') == 3).count() == 0) errors.push('Debe seleccionar una cotización para aprobar')
	if (extra == 2 && data.filter(x => x.get('estado') == 3).count() > 1) errors.push('Sólo dbe seleccionar una cotización para aprobar')
	if (extra == 0 && !data) errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones')
	return errors
}


function validarSolicitudAprobacionAdicionalServicio(cotizacion, aprobador, motivo) {
    const errors = [];
    if (!cotizacion || !cotizacion.get('id')) errors.push('Debe seleccionar una cotización válida.');
    if (!aprobador || !aprobador.id) errors.push('Debe seleccionar un aprobador adicional.');
    if (!motivo || motivo.trim().length === 0) errors.push('El motivo de la solicitud adicional es obligatorio');
    return errors;
}

const validateSolicitud = (data, extra=null) => {

	const errors = []

	if (data.get('estado') === 1) {
		
		data.get('servicios').map((s,n) => {
			
			if (s.get('compra_directa') == true){
				if (!s.get('fecha_cotizaciones') || s.get('fecha_cotizaciones') == '-0001-11-30 00:00:00')
                	errors.push(`El campo fecha cotizaciones es obligatorio`)
			}

			if (s.get('cotizaciones') && s.get('cotizaciones').count() > 0) {
				if (s.get('fecha_cotizaciones') === '-0001-11-30 00:00:00' || s.get('fecha_cotizaciones') === '' ) errors.push(`El campo fecha cotizaciones es obligatorio en servicio # ${n+1}`)
				if (s.get('fecha_cotizaciones') && moment().subtract('days', 1).isAfter(s.get('fecha_cotizaciones'))) errors.push('La fecha de cotizaciones no debe ser inferior a la de hoy')
				if (s.get('cotizaciones').count() == 0) errors.push(`Se requiere al menos un proveedor en servicio # ${n+1}`)	
				if (s.get('cotizaciones').count() > 0 && s.get('cotizaciones').filter(c => c.get('proveedore') == null).count() > 0) errors.push(`Todos los campos de los proveedores son requeridos en servicio # ${n+1}`)
			}
		})
		
	}




	if (data.get('estado') >= 2 ) {

		data.get('servicios').map((s,n) => {
			s.get('cotizaciones_aprobar').map((c,i) => {
				if (c.get('adjunto')) {
					if (! c.get('cotizado')) errors.push(`El valor unitario de la cotización es obligatorio en el servicio ${n+1}`)
					if (! c.get('iva')) errors.push(`El valor IVA de la cotización es obligatorio en el servicio ${n+1}`)
					if (! c.get('forma_pago') || c.get('forma_pago') == 0) errors.push(`La forma de pago es obligatorio en el servicio ${n+1}`)
					if (! c.get('proveedor_id')) errors.push(`Debe seleccionar un proveedor en el servicio ${n+1}`)
				}
			
			})
			

			if (s.get('cotizaciones_aprobar').filter(x=>x.get('recomendado')==true).count() == 0 && s.get('cotizaciones_aprobar').count() > 0) errors.push(`Se debe recomendar una cotización en el servicio ${n+1}`)

			
			//|| s.get('compra_directa') !== 0
		})
	} else if (data.get('estado') === 0) {
        if (!data.get('motivo_cancelacion')) errors.push('El campo motivo cancelación es obligatorio');
    }

	return errors
}






const switchServicios = (change, modificacion, servicios) => {

	const path = [...modificacion.attribute]

	modificacion.attribute = path[1]
	
	switch (change.get('op')) {
		
		case 'add':					
			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'create'
				modificacion.value.adjunto = null
				modificacion.value.proveedor_id = modificacion.value.proveedore && modificacion.value.proveedore.id
				modificacion.value.servicio = null
				modificacion.value.proveedore = null

			} else if(modificacion.attribute === "cotizaciones_aprobar") {
				modificacion.action = 'create'
                modificacion.attribute = 'cotizaciones'
                modificacion.value.adjunto = null
                modificacion.value.proveedor_id = null
                modificacion.value.proveedore = null
                modificacion.value.servicio = null
            }
			if (modificacion.attribute === 'cencos') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'selected') {
				modificacion.action = 'hidden'
			}


		break

		case 'replace':

			if (modificacion.attribute === 'cotizaciones' || modificacion.attribute === 'cotizaciones_aprobar') {
				modificacion.attribute = path[3]
				modificacion.entity = 'Cotizacione'				
				modificacion.id = servicios.getIn([...path.splice(0,3), 'id'])
			}

			if (modificacion.attribute === 'cencos') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'factura_compra_directa_servicios') {
				if (servicios.getIn([...path.slice(0,2), 'id'])) {
					 modificacion.attribute = path[2]
					 modificacion.entity = 'FacturaCompraDirectaServicios'
					 modificacion.id = servicios.getIn([...path.slice(0,2), 'id'])
				 } else {
					 modificacion.entity = 'Servicio',
					 modificacion.action = 'create'
					 delete modificacion.value.adjunto
					 delete modificacion.value.id
				}
			 }
			 if (modificacion.attribute === 'selected') {
				modificacion.action = 'hidden'
			}			 


		break

		case 'remove':
			if (modificacion.attribute === 'cencos') {
				modificacion.action = 'hidden'
			}
		break


	}	
}

const switchFacturaCompraDirecta = (change, modification, facturaCP) => {
    const path = [...modification.attribute]
    modification.attribute = path[0]

    switch (change.get('op')) {
        case 'add':
            if (modification.entity === 'FacturaCompraDirectaServicios') {
                modification.action = 'create'
            }
    }
}


const validateDocumento = (data, escontratoanual=false) => {
	const errors = []



	if (Number(data.get('tipo')) === 0) errors.push('El campo tipo de documento es obligatorio')
	if (data.get('tipo') == 2 && !data.get('fecha_inicio')) errors.push('El campo fecha inicio es obligatorio')
	if (!data.get('fecha_entrega')) errors.push('El campo fecha entrega es obligatorio')

	if (data.get('tipo') == 2 && data.get('fecha_inicio')) {
		if (!moment(data.get('fecha_inicio')).isSameOrAfter(moment().format('YYYY-MM-DD'))) errors.push('La fecha de inicio no debe ser inferior a hoy')
	}

	if (data.get('tipo') == 2 && data.get('fecha_inicio') && data.get('fecha_entrega')) {
		if (moment(data.get('fecha_inicio')).isAfter(data.get('fecha_entrega'))) errors.push('La fecha entrega no debe ser inferior a la fecha de inicio')
	}

	if (data.get('tipo') != 4 && Number(data.get('plantilla_id')) === 0) errors.push('El campo plantilla es obligatorio')
	if (Number(data.get('anticipo')) > 50) errors.push('El anticipo no debe ser superior al 50%')
	if (Number(data.get('anticipo')) > 0 && !data.get('pago_anticipo')) errors.push('La fecha de pago de anticipo es obligatioria si hay anticipo')
	if (Number(data.get('anticipo')) > 0 && !data.get('forma_pago_anticipo')) errors.push('La forma de pago de anticipo es obligatioria si hay anticipo')


	if (escontratoanual) {
		if (Number(data.get('documento_id')) === 0) errors.push('El campo número de contrato es obligatorio')
	}

	let cotizado = data.get('detalles').reduce((acum, detalle) => {
		acum += detalle.get('valor_con_iva') * detalle.get('cantidad')
		return acum
	}, 0)

	cotizado = parseFloat(cotizado.toFixed(2))
	const aiu_total = parseFloat(Number(data.get('aiu_total')).toFixed(2))
	
	//Lo mando a quitar Oscar el dia 12/07/2019 via Skype
	// if (cotizado !== aiu_total && data.get('tipo') != 4) {
	// 	errors.push('El valor total de los servicios es diferente al valor total')
	// }

	if (!data.get('almacen')) {
		errors.push('El campo Almacén es obligatorio')
	}

	
	return errors
}


/**
 * Valida que todos los campos esten diligenciados
 * @param {Object} data 
 */
 const validateFacturaCompraDirecta = (data) => {
    const errors = [];
    
    if (!data.get('razon_social') && !data.getIn(['proveedor', 'nombre'])) errors.push("Debe ingresar un proveedor")
    if (!data.get('no_factura')) errors.push("Debe ingresar el número de la factura")
    if (!data.get('fecha_compra')) errors.push("Ingrese una fecha de compra válida")
    if (!data.get('medio_pago')) errors.push("Debe ingresar una forma de pago")
    if (!data.get('valor_compra')) errors.push("Debe ingresar el valor de la compra")
    if (!data.get('adjunto')) errors.push("Debe adjuntar el archivo de la factura")
    const today = moment()
    if (data.get('fecha_compra') && moment(data.get('fecha_compra')).isAfter(today)) errors.push("La fecha de compra no debe ser superior a la de hoy")

    return errors
}

const switchDocumento = (change, modificacion) => {

    const path = [...modificacion.attribute]
	modificacion.attribute = path[0]

	switch (modificacion.attribute) {
		case 'aiu_administracion_value':
		case 'aiu_imprevistos_value':
		case 'aiu_utilidad_value':
		case 'aiu_iva_utilidad_value':
		case 'iva_value':
		case 'aiu_total':
		case 'todos_detalles':
			modificacion.action = 'hidden'
		break
	}

    switch (change.get('op')) {
        case 'add':
            if (modificacion.attribute === 'garantias') {
                modificacion.value = modificacion.value.id
                modificacion.action = 'attach'
            }
            break
        case 'remove':
            if (modificacion.attribute === 'garantias') {
				modificacion.action = 'detach'
            }
            break
    }
}

const addModificacion = (solicitud, unchaged) => {

	const modificaciones = []

	modificaciones.push({
		id: solicitud.get('id'),
		entity: 'Solicitude',
		value: {
			proyecto_evento: solicitud.get('proyecto_evento'),
			fecha_requerido: solicitud.get('fecha_requerido')
		},
		action: 'edit'
	})

	solicitud.get('servicios').valueSeq().forEach((servicio) => {

		if (servicio.get('id')) {

			modificaciones.push({
				id: servicio.get('id'),
				entity: 'Servicio',
				value: {
					descripcion: servicio.get('descripcion'),
					cantidad: servicio.get('cantidad'),
					fecha_cotizaciones: servicio.get('fecha_cotizaciones') != '-0001-11-30 00:00:00' ? servicio.get('fecha_cotizaciones') : null
				},
				action: 'edit'
			})

			const idx =  unchaged.get('servicios').findIndex(s => s.get('id') == servicio.get('id'));

			if (idx != -1) {

				const modificacionesCencos = getModificaciones(servicio.get('cencos'), unchaged.getIn(['servicios', idx, 'cencos']), 'DisCencoServicio')

				// Solo detectamos si hay cambios.
				if (modificacionesCencos.length > 0) { //Modificamos los cencos

					let cencos

					// 1 - Borramos todos los que estan en unchanged

					cencos = unchaged.getIn(['servicios', idx, 'cencos'])

					cencos.valueSeq().forEach(c => {
						modificaciones.push({
							id: c.getIn(['pivot', 'id']),
							entity: 'DisCencoServicio',
							action: 'delete'
						})
					})

					// 2 - Y agregamos los que estan en solicitud/servicios

					cencos = servicio.get('cencos')

					cencos.valueSeq().forEach(c => {
						modificaciones.push({
							entity: 'DisCencoServicio',
							value: {
								servicio_id: servicio.get('id'),
								cenco_id: c.getIn(['pivot', 'cenco_id']),
								porcentaje: c.getIn(['pivot', 'porcentaje'])
							},
							action: 'add'
						})
					})

				}
			}	

			// 3 - Agregamos cotizaciones si las hay en el estado creado

			if ((solicitud.get('estado') == 1) && servicio.get('cotizaciones').count() > 0) {

				const cotizaciones = servicio.get('cotizaciones');

				cotizaciones.forEach(c => {

					const value = c.toJS();
					value.servicio = null;
					value.adjunto = null;
					value.proveedore = null; 

					modificaciones.push({
						entity: 'Servicio',
						id: servicio.get('id'),
						attribute: 'cotizaciones',
						value: value,
						action: 'create'
					})

				})

			}

			
		} else {

			const cencos = [];

			servicio.get('cencos').valueSeq().forEach(cenco => {
				cencos.push({
					cenco_id: cenco.getIn(['pivot', 'cenco_id']),
					porcentaje: cenco.getIn(['pivot', 'porcentaje']),
					rubro_id: cenco.getIn(['pivot', 'rubro_id'])
				})
			})
			
			// Se modifico el backend para aceptar una relacion
			modificaciones.push({
				entity: 'Servicio',
				value: {
					solicitud_id: solicitud.get('id'),
					descripcion: servicio.get('descripcion'),
					valor: servicio.get('valor'),
					valor_con_iva: servicio.get('valor_con_iva'),
					cantidad: servicio.get('cantidad'),					
					estado: 1,
					cencos
				},
				action: 'add'
			})

		}

	})



	return modificaciones

}



























// WEBPACK FOOTER //
// ./src/actions/solicitudservicio.js